export default __webpack_public_path__ + "static/media/social-media.2b3ed4f7.png";